import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import '@babel/runtime/helpers/esm/toConsumableArray';
import '@babel/runtime/helpers/esm/objectSpread2';
import 'react';
import '../StyleContext.js';
import { toStyleStr } from '../util/index.js';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/defineProperty';
import './useCompatibleInsertionEffect.js';
import './useEffectCleanupRegister.js';
import '@babel/runtime/helpers/esm/extends';
import '@babel/runtime/helpers/esm/typeof';
import '../../../../../../rc-util@5.44.4_react-dom@18.3.1_react@18.3.1/node_modules/rc-util/es/warning.js';

var CSS_VAR_PREFIX = 'cssVar';
var extract = function extract(cache, effectStyles, options) {
  var _cache = _slicedToArray(cache, 4),
    styleStr = _cache[1],
    styleId = _cache[2],
    cssVarKey = _cache[3];
  var _ref5 = options || {},
    plain = _ref5.plain;
  if (!styleStr) {
    return null;
  }
  var order = -999;

  // ====================== Style ======================
  // Used for rc-util
  var sharedAttrs = {
    'data-rc-order': 'prependQueue',
    'data-rc-priority': "".concat(order)
  };
  var styleText = toStyleStr(styleStr, cssVarKey, styleId, sharedAttrs, plain);
  return [order, styleId, styleText];
};

export { CSS_VAR_PREFIX, extract };
